module.exports = __webpack_public_path__ + "static/img/ico_facebook.aac4598.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/images/ico/ico_facebook.svg
// module id = 29t5
// module chunks = 0